export default {
  DAYS: 365,
}
